import { render, staticRenderFns } from "./zhgl-compose.vue?vue&type=template&id=25dd8482&"
import script from "./zhgl-compose.vue?vue&type=script&lang=ts&"
export * from "./zhgl-compose.vue?vue&type=script&lang=ts&"
import style0 from "./zhgl-compose.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports